module.exports = __webpack_public_path__ + "static/media/bulgarian.5352a10d.png";